import { useMemo } from 'react';
import { ui } from '@procuros/datachecks';

import { useInterpolateVariables } from 'components/SchemableForm/contexts/SchemableFormVariablesContext/SchemableFormVariablesContext';
import { useEnumerableOptions } from 'components/WebEDI/helpers';

export const useInterpolatedEnumerableOptions = (config: ui.EnumerableField['type_config'] | undefined) => {
  const { options, hasResolved } = useEnumerableOptions(config);
  const interpolate = useInterpolateVariables();
  const interpolatedOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        label: interpolate(option.label),
        description: option.description ? interpolate(option.description) : option.description,
      })),
    [options, interpolate],
  );

  return { options: interpolatedOptions, hasResolved };
};
